import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Tooth, Arch, Quadrant } from '@libs/ui-lib';
import { ArchRowComponent } from '../arch-row/arch-row.component';
import { TeethSelectorMode } from '../../teeth-selector-dialog.vm';

@Component({
  selector: 'lib-teeth-grid',
  standalone: true,
  templateUrl: './teeth-grid.component.html',
  styleUrl: './teeth-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ArchRowComponent],
})
export class TeethGridComponent {
  public readonly teeth = input.required<Tooth[]>();
  public readonly selectedTeethPositions = input.required<number[]>();
  public readonly drawTreatments = input.required<boolean>();
  public readonly mode = input.required<TeethSelectorMode>();
  public readonly selectedArch = input<Arch[]>([]);
  public readonly selectedQuadrant = input<Quadrant[]>([]);

  public readonly archClicked = output<Arch>();
  public readonly quadrantClicked = output<Quadrant>();
  public readonly toothClicked = output<number>();

  protected readonly Quadrant = Quadrant;
}
